"use client";
import React, { useState } from "react";
import { Rank, RANKS } from "common";

export default function BettorCrown({ rank }: { rank: number }) {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <div className="relative h-[30px] w-[30px]">
      {isLoading && (
        <div className="absolute inset-0 bg-gray-300 animate-pulse rounded-full"></div>
      )}
        <img
          src={`/images/bettor/crowns/${RANKS[rank as Rank]}.webp`}
          alt={`Crown Rank ${rank}`}
          width={30}
          height={30}
          onLoad={() => setIsLoading(false)}
        />
    </div>
  );
}
